/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type NonUserDefragEmailResponseType = "No" | "NotSure" | "Yes" | "%future added value";
export type NonUserDefragSurvey_viewer = {
    readonly nonUserDefragEmailResponse: {
        readonly __typename: "NonUserDefragEmailResponse";
        readonly responseType: NonUserDefragEmailResponseType;
        readonly additionalInformation: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $refType": "NonUserDefragSurvey_viewer";
};
export type NonUserDefragSurvey_viewer$data = NonUserDefragSurvey_viewer;
export type NonUserDefragSurvey_viewer$key = {
    readonly " $data"?: NonUserDefragSurvey_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"NonUserDefragSurvey_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "emailInstanceId"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NonUserDefragSurvey_viewer",
    "selections": [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "emailInstanceId",
                    "variableName": "emailInstanceId"
                }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "nonUserDefragEmailResponse",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "responseType",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "additionalInformation",
                            "storageKey": null
                        }
                    ],
                    "type": "NonUserDefragEmailResponse",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = 'd627a0e545ae73dca804ef4515f338df';
export default node;
